import firebaseService from '../firebase/FirebaseService';

export const createCycle = async (payload) => {
    return firebaseService.createCycle(payload)
        .then((response) => {
            const cycleId = response.id
            return cycleId;
        })
        .catch(e => {
            return "error";
        });
}

export const updateCycle = async (cycleId, payload) => {
    return firebaseService.updateCycle(cycleId, payload)
        .then((response) => {
            return response;
        })
        .catch(e => {
            return "error";
        });
}

export const getCycles = async () => {
    return firebaseService.getCycles()
        .then((response) => {
            return response
        })
        .catch(error => {
            return []
        });
};

export const getCycleById = async (cycleId) => {
    return firebaseService.getCycleById(cycleId)
        .then((response) => {
            return response
        })
        .catch(error => {
            return {}
        });
};
